import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "as-injuries-suspensions" }
const _hoisted_2 = { class: "as-line-up-colunm-item" }
const _hoisted_3 = { class: "as-line-up-item as-line-up-item-team as-line-up-item-home" }
const _hoisted_4 = { class: "as-match__team" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "as-match__team-name" }
const _hoisted_7 = { class: "as-player as-player-row" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "as-player-shirt-name" }
const _hoisted_11 = {
  key: 0,
  class: "as-position"
}
const _hoisted_12 = { class: "as-player-injured" }
const _hoisted_13 = { class: "as-injured-suspended" }
const _hoisted_14 = {
  key: 0,
  "aria-hidden": "true"
}
const _hoisted_15 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "as-line-up-colunm-item" }
const _hoisted_17 = { class: "as-line-up-item as-line-up-item-team as-line-up-item-home" }
const _hoisted_18 = { class: "as-match__team" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "as-match__team-name" }
const _hoisted_21 = { class: "as-player as-player-row" }
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "as-player-shirt-name" }
const _hoisted_25 = {
  key: 0,
  class: "as-position"
}
const _hoisted_26 = { class: "as-player-injured" }
const _hoisted_27 = { class: "as-injured-suspended" }
const _hoisted_28 = {
  key: 0,
  "aria-hidden": "true"
}
const _hoisted_29 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_30 = {
  "aria-hidden": "true",
  style: {"position":"absolute","width":"0px","height":"0px","overflow":"hidden"}
}

import { computed } from "vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import type { ILineups, IMatch, IStartingPlayers } from "~src/interfaces";
import NoData from "~src/components/NoData.vue";
import StatsEnum from "~src/enums/team-detail/StatsEnum";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InjuriesSuspensions',
  props: {
    lineups: {},
    match: {},
    startingPlayers: {}
  },
  setup(__props: any) {

const matchDetailStore = useMatchDetailStore();



const screenWidth = computed(() => matchDetailStore.getScreenWidth);

const getPosition = (position: string) => {
  return StatsEnum.SHORT_POSITIONS[position as keyof typeof StatsEnum.SHORT_POSITIONS];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["as-line-up-colunm", {
        'as-line-up-colunm-sm': screenWidth.value < 370,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "as-match__team-logo",
              src: 
                _ctx.getImgUrlBySport(
                  'team',
                  _ctx.lineups?.coach?.home ? _ctx.lineups.coach?.home?.team_id : _ctx.match.home_team_id
                )
              
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.lineups?.coach?.home ? _ctx.lineups.coach?.home?.name : _ctx.match.home_team.name), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startingPlayers.home, (player, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "as-line-up-item as-line-up-item-home"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: _ctx.getLinkPlayerDetail(player),
                class: "as-player-name"
              }, [
                _createElementVNode("img", {
                  class: "as-player-logo",
                  src: _ctx.getImgUrlBySport('player', player.id)
                }, null, 8, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(player.name), 1),
                  (player.position)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(getPosition(player.position)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_8),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass(player.type === 1 ? 'as-injured' : 'as-suspended')
                  }, _toDisplayString(player.name_vi || player.name_en), 3)
                ]),
                (player.type === 1)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[0] || (_cache[0] = [
                      _createElementVNode("use", { "xlink:href": "#iconPlus" }, null, -1)
                    ])))
                  : (player.type === 2)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[1] || (_cache[1] = [
                        _createElementVNode("use", { "xlink:href": "#iconFinish" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              class: "as-match__team-logo",
              src: 
                _ctx.getImgUrlBySport(
                  'team',
                  _ctx.lineups?.coach?.away ? _ctx.lineups.coach?.away?.team_id : _ctx.match.away_team_id
                )
              
            }, null, 8, _hoisted_19),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.lineups?.coach?.away ? _ctx.lineups.coach?.away?.name : _ctx.match.away_team.name), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startingPlayers.away, (player, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "as-line-up-item as-line-up-item-away"
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("a", {
                href: _ctx.getLinkPlayerDetail(player),
                class: "as-player-name"
              }, [
                _createElementVNode("img", {
                  class: "as-player-logo",
                  src: _ctx.getImgUrlBySport('player', player.id)
                }, null, 8, _hoisted_23),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(player.name), 1),
                  (player.position)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(getPosition(player.position)), 1))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_22),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, [
                  _createElementVNode("span", {
                    class: _normalizeClass(player.type === 1 ? 'as-injured' : 'as-suspended')
                  }, _toDisplayString(player.name_vi || player.name_en), 3)
                ]),
                (player.type === 1)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _cache[2] || (_cache[2] = [
                      _createElementVNode("use", { "xlink:href": "#iconPlus" }, null, -1)
                    ])))
                  : (player.type === 2)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_29, _cache[3] || (_cache[3] = [
                        _createElementVNode("use", { "xlink:href": "#iconFinish" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ], 2),
    (!_ctx.startingPlayers.home.length && !_ctx.startingPlayers.away.length)
      ? (_openBlock(), _createBlock(NoData, {
          key: 0,
          title: "Không có dữ liệu",
          modifyClass: "as-h-auto"
        }))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("svg", _hoisted_30, _cache[4] || (_cache[4] = [
      _createElementVNode("symbol", {
        id: "iconFinish",
        width: "16",
        height: "16",
        viewbox: "0 0 16 16"
      }, [
        _createElementVNode("g", { "clip-path": "url(#clip0_153_6988)" }, [
          _createElementVNode("path", {
            d: "M4.04901 15.9865L4.34357 15.9041C4.6269 15.825 4.7924 15.5311 4.71323 15.2477L1.34542 3.19565C1.2979 3.02557 1.18475 2.88133 1.03088 2.79467C0.877004 2.70801 0.695006 2.68603 0.524923 2.73356L0.486882 2.74418C0.132682 2.84314 -0.0742295 3.2105 0.02473 3.5647L3.39262 15.6168C3.47179 15.9001 3.76567 16.0656 4.04901 15.9865Z",
            fill: "#0C72CB"
          }),
          _createElementVNode("path", {
            d: "M15.9093 7.56415C14.8413 7.03161 13.8533 6.35189 12.9741 5.54484C12.9002 5.47719 12.8713 5.37335 12.8996 5.27725C13.3352 3.6293 13.6587 1.95375 13.8679 0.26208C13.901 -0.0192994 13.7493 -0.102058 13.5893 0.0910454C10.45 3.84553 5.01826 -0.595851 1.78516 2.81656C1.82397 2.88924 1.85451 2.96604 1.87619 3.04553L4.06102 10.869C7.29964 7.49794 12.7121 11.9117 15.8458 8.16553C16.0058 7.97242 16.0362 7.61932 15.9093 7.56415Z",
            fill: "#0C72CB"
          })
        ]),
        _createElementVNode("defs", null, [
          _createElementVNode("clipPath", { id: "clip0_153_6988" }, [
            _createElementVNode("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ])
      ], -1),
      _createElementVNode("symbol", {
        id: "iconPlus",
        width: "16",
        height: "16",
        viewbox: "0 0 16 16"
      }, [
        _createElementVNode("g", { "clip-path": "url(#clip0_153_7005)" }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM9.85059 3.07816L9.85056 3.07812H6.14947L6.14941 3.07819V6.14944L3.07809 6.14947V6.14953L3.07812 9.85053H3.07822H6.14944L6.14947 12.9218L6.1495 12.9219H9.85066V9.85056L12.922 9.85053L12.9219 6.14944H9.85063L9.85059 3.07816Z",
            fill: "#CC4545"
          })
        ]),
        _createElementVNode("defs", null, [
          _createElementVNode("clipPath", { id: "clip0_153_7005" }, [
            _createElementVNode("rect", {
              width: "16",
              height: "16",
              fill: "white"
            })
          ])
        ])
      ], -1)
    ])))
  ]))
}
}

})